<div *ngIf="itens" class="pl-2 pr-2 pb-5 main-content">
  <div class="counter">
    <div class="info1 pl-2" i18n>{{ itens.length }} itens encontrados</div>
  </div>
  <div
    class="row mt-2 gcc-itens pl-2 pr-2 pb-5"
    *ngIf="grupo.tipo == 'BANNER'; else itemProdutoBlock"
  >
    <div
      *ngFor="let item of itens"
      class="col-xl-12 col-lg-4 col-6 mt-4 p-2"
      id="item-banner-{{ item.id }}"
    >
      <a
        href="{{ item.redirectUrl ? item.redirectUrl : 'javascript:void(0);' }}"
        target="{{ item.redirectUrl ? '_blank' : '' }}"
      >
        <div class="mt-1 item-descricao item-banner-descricao">
          {{
            item.descricao.length > itemDescrLen
              ? (item.descricao | slice : 0 : itemDescrLen) + "..."
              : item.descricao
          }}
        </div>
      </a>
      <a
        href="{{ item.redirectUrl ? item.redirectUrl : 'javascript:void(0);' }}"
        target="{{ item.redirectUrl ? '_blank' : '' }}"
      >
        <div class="item-img">
          <div *ngIf="item.thumbnailUrl">
            <img
              src="{{ API_IMAGENS }}/thumbnail/{{ item.thumbnailUrl }}"
              class="bottom img-fluid item-banner-img"
            />
          </div>
        </div>
      </a>
    </div>
  </div>
  <ng-template class="row mt-2 gcc-itens pl-2 pr-2 pb-5" #itemProdutoBlock>
    <div class="row mt-2 gcc-itens pl-2 pr-2 pb-5">
      <div
        *ngFor="let item of itens"
        class="col-xl-3 col-lg-4 col-6 p-2 item-produto"
        id="item-produto-{{ item.id }}"
      >
        <a>
          <div class="item-img">
            <div *ngIf="item.thumbnailUrl">
              <img
                src="{{ API_IMAGENS }}/thumbnail/{{ item.thumbnailUrl }}"
                [style.max-height.px]="itemHeight"
                class="bottom img-fluid item-produto-img"
              />
            </div>
          </div>
        </a>
        <div
          class="mt-1 item-descricao item-produto-descricao"
          [style.height.px]="itemDescrHeight"
          [style.font-size.rem]="itemDescrFontSize"
        >
          {{
            item.descricao.length > itemDescrLen
              ? (item.descricao | slice : 0 : itemDescrLen) + "..."
              : item.descricao
          }}
        </div>
        <div class="mt-2 item-produto-download">
          <button
            (click)="downloadFile(item.fileUrl)"
            class="btn btn-secondary"
            [style.font-size.rem]="itemIndispFontSize"
          >
            Download
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
